"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.truncatedValueWithSuffix = exports.toFixed = exports.getCurrencyTranslation = exports.getCurrencyMapping = exports.formatNumberForPenceWith2DecimalPlaces = exports.convertToCurrencyWithScaleSuffixTranslationKeyWithRounding = exports.convertToCurrencyWithScaleSuffixTranslationKeyForHK = exports.convertToCurrencyWithScaleSuffixTranslationKeyAnd2DecimalsWithNoRoundingValue = exports.convertToCurrencyWithoutDecimals = exports.convertToCurrencyForNav = exports.convertToCurrency = exports.convertToCommaSeparatedNumber = undefined;

var _number_utility = require("./number_utility.js");

var _number_utility2 = _interopRequireDefault(_number_utility);

var _ramda = require("ramda");

var _fund_utility = require("./fund_utility");

var _string_utility = require("../../../packages/common-utilities/src/string_utility.js");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _formatted_number = require("../../../app/implementation/components/global_components/formatted_number");

var _formatted_number2 = _interopRequireDefault(_formatted_number);

var _reactIntl = require("react-intl");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var currencyMap = {
  'AUD': '$',
  'USD': '$',
  'HKD': 'HK$'
};

var currencyFormatMap = {
  "gb": "code",
  "us": "symbol",
  "ca": "symbol",
  "mx": "symbol",
  "jp": "symbol"
};

var FALL_BACK_VALUE = '-';

var CurrencyUtility = {
  convertToCommaSeparatedNumber: function convertToCommaSeparatedNumber(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  convertToCurrency: function convertToCurrency(amount, isoCode) {
    var fallbackValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '-';
    var country = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    return (0, _ramda.isNil)(amount) || amount === FALL_BACK_VALUE ? fallbackValue : _getCurrencyMapping(isoCode, country) + _number_utility2.default.convertToAmount(amount, 2);
  },
  convertToCurrencyCode: function convertToCurrencyCode(amount, isoCode) {
    var fallbackValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '-';

    return (0, _ramda.isNil)(amount) || amount === FALL_BACK_VALUE ? fallbackValue : isoCode + " " + _number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToAmount(amount, 2));
  },
  convertToCurrencyIntoMillionsWithCurrencyCodeAndSuffix: function convertToCurrencyIntoMillionsWithCurrencyCodeAndSuffix(amount) {
    var roundedValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var currencyCode = arguments[2];

    var calculatedAmount = void 0;
    if (amount >= 1000000) {
      calculatedAmount = (amount / 1000000).toFixed(roundedValue) + " Mn";
    } else {
      return amount.toFixed(roundedValue);
    }
    return currencyCode + " " + calculatedAmount;
  },
  convertToCurrencyForNav: function convertToCurrencyForNav(amount, isoCode, fundTypeCode, country, decimalPlaces) {
    var fallbackValue = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : FALL_BACK_VALUE;

    return (0, _ramda.isNil)(amount) || amount === fallbackValue ? fallbackValue : _getCurrencyMapping(isoCode, country) + (0, _fund_utility.getNAVValue)(fundTypeCode, amount, country, decimalPlaces);
  },
  convertToCurrencyWithoutDecimals: function convertToCurrencyWithoutDecimals(amount, isoCode) {
    return (0, _ramda.isNil)(amount) || amount === FALL_BACK_VALUE || amount === "NaN" ? FALL_BACK_VALUE : _getCurrencyMapping(isoCode) + amount;
  },
  convertToCurrencyWithCommasAnd2DecimalsWithNoRounding: function convertToCurrencyWithCommasAnd2DecimalsWithNoRounding(amount, isoCode) {
    return (0, _ramda.isNil)(amount) || amount === FALL_BACK_VALUE ? FALL_BACK_VALUE : _getCurrencyMapping(isoCode) + _number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToTwoDecimalFixedNumberWithNoRounding(amount));
  },
  convertToCurrencyWithScaleSuffixAnd2DecimalsWithNoRounding: function convertToCurrencyWithScaleSuffixAnd2DecimalsWithNoRounding(amount, isoCode) {
    return (0, _ramda.isNil)(amount) ? FALL_BACK_VALUE : _getCurrencyMapping(isoCode) + truncatedValueWithSuffix(_number_utility2.default.convertToTwoDecimalFixedNumberWithNoRounding(amount));
  },
  convertToCurrencyWithScaleSuffixTranslationKeyAnd2DecimalsWithNoRoundingValue: function convertToCurrencyWithScaleSuffixTranslationKeyAnd2DecimalsWithNoRoundingValue(amount) {
    var decimalPoints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

    if ((0, _ramda.isNil)(amount)) {
      return FALL_BACK_VALUE;
    }
    var calculatedAmount = {};
    var value = amount > 1000000 ? amount++ : amount;

    var reg = new RegExp("(\\d+\\.*\\d{0," + decimalPoints + "})(\\d*)");

    if (value >= 1000000000000) {
      calculatedAmount.value = (value / 1000000000000).toString().match(reg)[1];
      calculatedAmount.translationKey = 'pdp-currency-in-trillions';
    } else if (value >= 1000000000) {
      calculatedAmount.value = (value / 1000000000).toString().match(reg)[1];
      calculatedAmount.translationKey = 'pdp-currency-in-billions';
    } else if (value >= 100000) {
      calculatedAmount.value = (value / 1000000).toString().match(reg)[1];
      calculatedAmount.translationKey = 'pdp-currency-in-millions';
    } else {
      return value.toString().match(reg)[1];
    }

    return calculatedAmount;
  },
  convertToCurrencyWithScaleSuffixTranslationKeyAnd2DecimalsWithNoRoundingValueMillion: function convertToCurrencyWithScaleSuffixTranslationKeyAnd2DecimalsWithNoRoundingValueMillion(amount) {
    if ((0, _ramda.isNil)(amount)) {
      return FALL_BACK_VALUE;
    } else {
      var calculatedAmount = {};
      var value = amount;
      value++;
      var reg = new RegExp("(\\d+\\.\\d{2})(\\d)");
      var trimmedValue = (value / 1000000).toString().match(reg);
      calculatedAmount.value = trimmedValue[1];
      calculatedAmount.translationKey = 'pdp-currency-in-millions';
      return calculatedAmount;
    }
  },
  convertToCurrencyWithScaleSuffixTranslationKeyForHK: function convertToCurrencyWithScaleSuffixTranslationKeyForHK(amount) {
    var decimalPoints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    if ((0, _ramda.isNil)(amount)) {
      return FALL_BACK_VALUE;
    } else {
      var nDigits = decimalPoints + 2;
      var calculatedAmount = {};
      var value = amount > 1000000 ? amount++ : amount;
      var reg = new RegExp("(\\d+\\.*\\d{0," + nDigits + "})(\\d*)");

      if (value >= 1000000000000) {
        var result = (value / 1000000000000).toString().match(reg)[decimalPoints];
        calculatedAmount.value = toFixed(parseFloat(result), decimalPoints);
        calculatedAmount.translationKey = 'pdp-currency-in-trillions';
      } else if (value >= 1000000000) {
        var _result = (value / 1000000000).toString().match(reg)[decimalPoints];
        calculatedAmount.value = toFixed(parseFloat(_result), decimalPoints);
        calculatedAmount.translationKey = 'pdp-currency-in-billions';
      } else if (value >= 100000) {
        var _result2 = (value / 1000000).toString().match(reg)[decimalPoints];
        calculatedAmount.value = toFixed(parseFloat(_result2), decimalPoints);
        calculatedAmount.translationKey = 'pdp-currency-in-millions';
      } else {
        calculatedAmount.value = value.toString().match(reg)[decimalPoints];
        calculatedAmount.translationKey = 'pdp-currency-in-normal';
      }
      return calculatedAmount;
    }
  },
  convertToCurrencyWithScaleSuffixTranslationKeyWithRounding: function convertToCurrencyWithScaleSuffixTranslationKeyWithRounding(amount) {
    var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

    if ((0, _ramda.isNil)(amount) || typeof amount !== "number") {
      return FALL_BACK_VALUE;
    }
    var calculatedAmount = {};

    if (amount >= 1000000000000) {
      calculatedAmount.value = (amount / 1000000000000).toFixed(decimalPlaces);
      calculatedAmount.translationKey = 'pdp-currency-in-trillions';
    } else if (amount >= 1000000000) {
      calculatedAmount.value = (amount / 1000000000).toFixed(decimalPlaces);
      calculatedAmount.translationKey = 'pdp-currency-in-billions';
    } else if (amount >= 1000000) {
      calculatedAmount.value = (amount / 1000000).toFixed(decimalPlaces);
      calculatedAmount.translationKey = 'pdp-currency-in-millions';
    } else if (amount >= 100000) {
      calculatedAmount.value = (amount / 1000000).toFixed(decimalPlaces);
      calculatedAmount.translationKey = 'pdp-currency-in-millions';
    } else {
      return amount.toFixed(decimalPlaces);
    }

    return calculatedAmount;
  },
  formatCurrencyInRegionTranslatedFormat: function formatCurrencyInRegionTranslatedFormat(country, value, currency, fundTypeCode, decimalPlaces) {
    var fallbackValue = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '-';
    var visibleData = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

    if ((0, _ramda.isNil)(value) || value === FALL_BACK_VALUE) {
      return fallbackValue;
    }
    return _string_utility2.default.renderFormattedLabel("{currency}{amount}", "currency-amount", {
      fundType: fundTypeCode,
      amount: (0, _fund_utility.getNAVValue)(fundTypeCode, value, country, decimalPlaces, visibleData),
      currency: getCurrencyTranslation(currency)
    });
  },
  formatCurrencyInRegionTranslatedFormatAsIs: function formatCurrencyInRegionTranslatedFormatAsIs(country, value, currency, fundTypeCode) {
    var fallbackValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '-';

    if ((0, _ramda.isNil)(value) || value === FALL_BACK_VALUE) {
      return fallbackValue;
    }
    return _string_utility2.default.renderFormattedLabel("{currency}{amount}", "currency-amount", {
      amount: value,
      currency: getCurrencyTranslation(currency)
    });
  },
  formatNumberForPenceWith2DecimalPlaces: function formatNumberForPenceWith2DecimalPlaces(value) {
    if (!(0, _ramda.isNil)(value) && value !== FALL_BACK_VALUE) {
      return _number_utility2.default.convertToTwoDecimalFixedNumberWithNoRounding(value) + 'p';
    }
  },
  formattedNumberForLocale: function formattedNumberForLocale(value) {
    var minDecimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

    return _react2.default.createElement(_reactIntl.FormattedNumber, { value: value, style: "decimal", minimumFractionDigits: minDecimalPlaces });
  },
  getCurrencyFormatMap: function getCurrencyFormatMap(country) {
    return currencyFormatMap[country];
  },
  getCurrencyMapping: function getCurrencyMapping(isoCode, country) {
    var currencyCode = void 0;
    if ((0, _ramda.isNil)(country)) {
      if (!(0, _ramda.isNil)(isoCode) && !(isoCode in currencyMap)) {
        currencyCode = isoCode + ' ';
      } else {
        currencyCode = (0, _ramda.isNil)(isoCode) ? '$' : currencyMap[isoCode];
      }
    } else {
      currencyCode = currencyFormatMap[country] === 'symbol' ? _getCurrencyMapping(isoCode) : isoCode + ' ';
    }
    return currencyCode;
  },
  getCurrencyTranslation: function getCurrencyTranslation(currencyCode) {
    return _string_utility2.default.renderFormattedLabel(currencyCode, "currency-code-" + _string_utility2.default.toUpper(currencyCode));
  },
  getCurrencyTranslationWithIntl: function getCurrencyTranslationWithIntl(intl, currencyCode) {
    if ((0, _ramda.isNil)(intl)) {
      return currencyCode + ' ';
    }
    return _string_utility2.default.getLocalizedString(intl, currencyCode, "currency-code-" + _string_utility2.default.toUpper(currencyCode)) + ' ';
  },
  getFormattedNavValue: function getFormattedNavValue(currencyCodeMode, fundData, numberOfDigits, nav, navValue) {
    var fallbackValue = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '—';

    if (currencyCodeMode === 'asIs') {
      return navValue;
    } else if ((0, _ramda.isNil)(nav)) {
      return fallbackValue;
    } else if (currencyCodeMode === 'isoCode') {
      var formattedNAV = (0, _ramda.compose)(function (value) {
        return _number_utility2.default.convertToEuropeanFormat(value, fundData.europeanNumberFormat);
      }, _number_utility2.default.convertToNumberWithCommas, function (value) {
        return _number_utility2.default.convertToAmount(value, numberOfDigits);
      })(nav);
      if (fundData.intraDayNav) {
        return _react2.default.createElement(
          "span",
          null,
          fundData.shareclassCurrencyCode,
          " ",
          formattedNAV
        );
      } else {
        return _react2.default.createElement(
          "div",
          null,
          fundData.shareclassCurrencyCode,
          " ",
          formattedNAV
        );
      }
    } else if (currencyCodeMode === 'pence') {
      return formatNumberForPenceWith2DecimalPlaces(nav);
    } else if (currencyCodeMode === 'thousandSeparator') {
      return _number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToAmount(nav, numberOfDigits));
    } else {
      return _number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToAmount(nav, numberOfDigits));
    }
  },
  getFundSizeBasedOnRules: function getFundSizeBasedOnRules(formattingRules, country, marketNav, currencyCode, numberFormat, role) {
    if ((0, _ramda.isNil)(marketNav)) {
      return FALL_BACK_VALUE;
    }

    var formattedMarketNav = void 0;

    if ((0, _ramda.includes)("AUM_WITH_ROUNDING", formattingRules)) {
      var digits = (0, _ramda.includes)("AUM_WITH_ROUNDING_1_DIGIT", formattingRules) ? 1 : 2;
      formattedMarketNav = convertToCurrencyWithScaleSuffixTranslationKeyWithRounding(marketNav, digits);
    } else if ((0, _ramda.includes)("AUM_IN_MILLIONS", formattingRules)) {
      var hkCalculatedAmount = convertToCurrencyWithScaleSuffixTranslationKeyForHK(marketNav);
      formattedMarketNav = hkCalculatedAmount.value;
      return _string_utility2.default.renderFormattedLabel(marketNav, hkCalculatedAmount.translationKey, {
        amount: convertToCommaSeparatedNumber(formattedMarketNav),
        currency: getCurrencyTranslation(currencyCode),
        role: role
      });
    } else {
      formattedMarketNav = convertToCurrencyWithScaleSuffixTranslationKeyAnd2DecimalsWithNoRoundingValue(marketNav);
    }

    var returnValue = void 0;

    if ((0, _ramda.isNil)(formattedMarketNav.translationKey)) {
      returnValue = _getCurrencyMapping(currencyCode, country) + formattedMarketNav;
    } else {
      returnValue = _string_utility2.default.renderFormattedLabel(FALL_BACK_VALUE, formattedMarketNav.translationKey, {
        amount: _formatted_number2.default.prototype.numberFormatter(formattedMarketNav.value, numberFormat),
        currency: _getCurrencyMapping(currencyCode, country),
        minimumFractionDigits: 2,
        role: role
      });
    }

    return returnValue;
  },
  toFixed: function toFixed(num, precision) {
    return (+(Math.round(+(num + 'e' + precision)) + 'e' + -precision)).toFixed(precision);
  },
  truncatedValueWithSuffix: function truncatedValueWithSuffix(originalValue) {
    var value = originalValue;
    var suffix = "";
    var returnValue = originalValue;
    if (originalValue < 0) {
      value--;
      value = Math.abs(value);
    } else {
      value++;
    }
    var reg = new RegExp("(\\d+\\.?\\d{0,2})(\\d*)");
    if (value >= 1000000000000) {
      var trimmedValue = (value / 1000000000000).toString().match(reg);
      returnValue = trimmedValue[1];
      suffix = 'tn';
    } else if (value >= 1000000000) {
      var _trimmedValue = (value / 1000000000).toString().match(reg);
      returnValue = _trimmedValue[1];
      suffix = 'bn';
    } else if (value >= 100000) {
      var _trimmedValue2 = (value / 1000000).toString().match(reg);
      returnValue = _trimmedValue2[1];
      suffix = 'mn';
    } else {
      return originalValue;
    }

    returnValue = _number_utility2.default.convertToEuropeanFormat(returnValue, false);

    if (originalValue < 0) {
      returnValue = "-" + returnValue;
    }

    return returnValue + suffix;
  }
};

exports.default = CurrencyUtility;
var convertToCommaSeparatedNumber = CurrencyUtility.convertToCommaSeparatedNumber,
    convertToCurrency = CurrencyUtility.convertToCurrency,
    convertToCurrencyForNav = CurrencyUtility.convertToCurrencyForNav,
    convertToCurrencyWithoutDecimals = CurrencyUtility.convertToCurrencyWithoutDecimals,
    convertToCurrencyWithScaleSuffixTranslationKeyAnd2DecimalsWithNoRoundingValue = CurrencyUtility.convertToCurrencyWithScaleSuffixTranslationKeyAnd2DecimalsWithNoRoundingValue,
    convertToCurrencyWithScaleSuffixTranslationKeyForHK = CurrencyUtility.convertToCurrencyWithScaleSuffixTranslationKeyForHK,
    convertToCurrencyWithScaleSuffixTranslationKeyWithRounding = CurrencyUtility.convertToCurrencyWithScaleSuffixTranslationKeyWithRounding,
    formatNumberForPenceWith2DecimalPlaces = CurrencyUtility.formatNumberForPenceWith2DecimalPlaces,
    _getCurrencyMapping = CurrencyUtility.getCurrencyMapping,
    getCurrencyTranslation = CurrencyUtility.getCurrencyTranslation,
    toFixed = CurrencyUtility.toFixed,
    truncatedValueWithSuffix = CurrencyUtility.truncatedValueWithSuffix;
exports.convertToCommaSeparatedNumber = convertToCommaSeparatedNumber;
exports.convertToCurrency = convertToCurrency;
exports.convertToCurrencyForNav = convertToCurrencyForNav;
exports.convertToCurrencyWithoutDecimals = convertToCurrencyWithoutDecimals;
exports.convertToCurrencyWithScaleSuffixTranslationKeyAnd2DecimalsWithNoRoundingValue = convertToCurrencyWithScaleSuffixTranslationKeyAnd2DecimalsWithNoRoundingValue;
exports.convertToCurrencyWithScaleSuffixTranslationKeyForHK = convertToCurrencyWithScaleSuffixTranslationKeyForHK;
exports.convertToCurrencyWithScaleSuffixTranslationKeyWithRounding = convertToCurrencyWithScaleSuffixTranslationKeyWithRounding;
exports.formatNumberForPenceWith2DecimalPlaces = formatNumberForPenceWith2DecimalPlaces;
exports.getCurrencyMapping = _getCurrencyMapping;
exports.getCurrencyTranslation = getCurrencyTranslation;
exports.toFixed = toFixed;
exports.truncatedValueWithSuffix = truncatedValueWithSuffix;